export default "__VITE_ASSET__CyO4MwNh__"